import React, { FC, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { onDemandVideosType } from 'src/components/OnDemandGallery/videos'
import Amplitude from 'src/utils/amplitudeHelper'
import { onDemandCategoryType } from '../categories'
import { setPageTitle, setPreviousPage } from '../../../ducks/onDemand'
import { StyledModal } from './styled'
import routes from 'src/routes'

enum UrlType {
  'mailto',
  'external',
  'internal',
}

function getLinkType(url: string): UrlType {
  if (url.startsWith('mailto')) {
    return UrlType.mailto
  }

  if (url.startsWith('http') || url.startsWith('//')) {
    return UrlType.external
  }

  return UrlType.internal
}

const externalAnchorProps = {
  target: '_blank',
  rel: 'noopener noreferrer',
}

interface MainCategoryTypes {
  category: onDemandCategoryType
}

const MainCategory: FC<MainCategoryTypes> = ({ category }) => {
  const dispatch = useDispatch()
  const [currentVideo, setCurrentVideo] = useState<null | onDemandVideosType>(null)

  const closeVimeoPlayer = () => {
    setCurrentVideo(null)
  }

  useEffect(() => {
    dispatch(setPageTitle(category.categoryName))
    dispatch(setPreviousPage(routes.onDemand))
  }, [category.categoryName, dispatch])

  return (
    <div className="grid-container">
      {category.videos &&
        category.videos.map((item) => (
          <React.Fragment key={item.vimeoId}>
            <div
              onClick={() => {
                setCurrentVideo(item)
                Amplitude.viewGalleryVideo(item.title, category.categoryName)
              }}
              className="card-thumbnail"
            >
              <img src={item.thumbnail} width="100%" alt="thumbnail" />
              {item.title && item.title.length && <p className="fs-sm">{item.title}</p>}
            </div>
          </React.Fragment>
        ))}
      <StyledModal show={currentVideo !== null} onHide={closeVimeoPlayer} size="lg" aria-labelledby="vimeoPlayer" centered>
        <Modal.Header closeButton>
          <Modal.Title id="vimeoPlayer">
            <b>{currentVideo?.title}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="vimeoContainer">
            <iframe
              src={`https://player.vimeo.com/video/${currentVideo?.vimeoId}?autoplay=1`}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              title="Vimeo Video"
            ></iframe>
            <script src="https://player.vimeo.com/api/player.js"></script>
          </div>
        </Modal.Body>
        {currentVideo?.buttonUrl && (
          <Modal.Footer>
            {getLinkType(currentVideo.buttonUrl) === UrlType.internal ? (
              <Link to={currentVideo.buttonUrl} className="btn btn-warning w-100">
                {currentVideo.buttonText}
              </Link>
            ) : (
              <a
                href={currentVideo.buttonUrl}
                className="btn btn-warning w-100"
                // inject target="_blank" and rel="noopener" props if url is external site
                {...(getLinkType(currentVideo.buttonUrl) === UrlType.external ? externalAnchorProps : {})}
              >
                {currentVideo.buttonText}
              </a>
            )}
          </Modal.Footer>
        )}
      </StyledModal>
    </div>
  )
}

export default MainCategory
